import { render } from "./FlowCard.vue?vue&type=template&id=5ef107ce"
import script from "./FlowCard.vue?vue&type=script&lang=js"
export * from "./FlowCard.vue?vue&type=script&lang=js"
script.render = render

export default script